import React from "react";
import "./Footer.css";

export default function Header(props) {
  return (
    <div className="footer">
      <a
        className="App-link2"
        href="https://memeshib.org"
        target="_blank"
        rel="noopener noreferrer"
      >
        MemeShib.org
      </a>
    </div>
  );
}
